import { animate, state, style, transition, trigger } from "@angular/animations";
import { Component, Inject, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
  MatDialog as MatDialog,
} from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { forkJoin, of, switchMap } from "rxjs";
import { slideTrigger } from "src/app/events-calendar/common/animation/triggers/slideTrigger";

import { MediaService } from "src/app/new-media/common/media.service";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { SecurityComponent } from "src/app/views/security/security.component";
import { SiteService as SiteServiceCulture } from "src/app/services/site.service";

@Component({
  selector: "app-add-edit-folder",
  templateUrl: "./add-edit-folder.component.html",
  styleUrls: ["./add-edit-folder.component.css"],
  animations: [
    slideTrigger,
    trigger("zipper", [
      state(
        "collapsed",
        style({
          height: "0px",
          overflow: "hidden",
          paddingTop: "0px",
          paddingBottom: "0px",
        })
      ),
      state(
        "expanded",
        style({
          height: "*",
          paddingTop: "*",
          paddingBottom: "*",
        })
      ),
      transition("collapsed <=> expanded", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class AddEditFolderComponent implements OnInit {
  reference: any;
  @Input() parentId: any = {};


  public form = new FormGroup({
    id: new FormControl(0),
    parentId: new FormControl(null),
    thumbnailId: new FormControl(null),
    // title: new FormControl("", [Validators.required]),
    order: new FormControl("", [Validators.min(0)]),
    // description: new FormControl(""),
    // cultureId: new FormControl("", [Validators.required]),
    mediaFoldersDetails: new FormArray([]),
  });
  openRole = false;
  activeTab = 0;
  activeInnerTab = 1;
  siteCultures = [];
  folderId = null;
  isEditFolder = false;
  index2 = 0;
  constructor(
    public siteService: SiteService,
    private mdeiaService: MediaService,
    private snotifyService: ToastrService,
    private activeRouter: ActivatedRoute,
      public siteServiceCulture: SiteServiceCulture,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AddEditFolderComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.reference = data;
  }

  ngOnInit() {

  this.siteServiceCulture.getUsedSiteCultures(2)
      .pipe(
        switchMap((res: any) => {
          this.siteCultures = res;

          if (this.reference.method === "Edit") {
            const observables = res.map((culture: any) =>
              this.mdeiaService.geFolderDetailsbyCultureId(
                culture.id,
                this.reference.folder.parentId
              )
            );

            return forkJoin(observables);
          }

          return of(null);
        })
      )
      .subscribe((results) => {
        this.pageInitilaize(results);
      });
  }
  pageInitilaize(folderDetails) {
    this.index2++;
    this.initilaizeCulturesForm(folderDetails);
    this.form.updateValueAndValidity();
  }

  updateActiveTab(index: number) {
    this.activeTab = this.activeTab === index ? null : index;
    // this.activeInnerTab = v;
  }

  initilaizeCulturesForm(folderDetails) {
    if (this.siteCultures && this.siteCultures.length) {
      let foundCulture;
      if (!folderDetails) {
          this._parentId.setValue(this.reference.folder.parentId
            ? this.reference.folder.parentId
            : null);
        for (let index = 0; index < this.siteCultures.length; index++) {
          const cultureInforamtion = new FormGroup({
            title: new FormControl(null, [Validators.required]),
            cultureId: new FormControl(this.siteCultures[index].id),
            description: new FormControl(""),
            thumbnailId: new FormControl(null),
            cultureCode: new FormControl(this.siteCultures[index].name),
          });
          this._folderDetails.push(cultureInforamtion);
        }
      } else {
        for (let index = 0; index < folderDetails.length; index++) {
          this._id.setValue(folderDetails[index] ? folderDetails[index].folderId : 0);


          this._order.setValue(folderDetails[index] ? folderDetails[index].order : 0);
          this._parentId.setValue(this.reference.folder.parentFolderId
            ? this.reference.folder.parentFolderId
            : null);
          const cultureInforamtion = new FormGroup({
            title: new FormControl(folderDetails[index] ? folderDetails[index].title : "", [
              Validators.required,
            ]),
            cultureId: new FormControl(
              folderDetails[index].cultureId || this.siteCultures[index].id
            ),
            description: new FormControl(
              folderDetails[index] ? folderDetails[index].description : ""
            ),
            thumbnailId: new FormControl(null),
            order: new FormControl(folderDetails[index] ? folderDetails[index].order : 0, [
              Validators.min(0),
            ]),

            cultureCode: new FormControl(
              this.siteCultures.find((x) => x.id == folderDetails[index].cultureId) ? this.siteCultures.find((x) => x.id == folderDetails[index].cultureId)
                .name : this.siteCultures[index].name
            ),
          });
          (this.form.get('mediaFoldersDetails') as FormArray).push(cultureInforamtion)
        }
      }
    }
    this._folderDetails.updateValueAndValidity();

  }


//     getUsedCulture() {
//  subscribe(
//       res => {
//         this.siteCultures = res;
//         if (this.id) {
//           this.getcategoryById();
//         } else {
//           this.form.setControl('categoryDetails', this.setNewCategoryCultures(this.siteCultures));
//         }
//       },
//       err => this.snotifyService.error(err.message)
//     );
//   }





  updateSecurity() {
    this.openRole = true;

    this.mdeiaService
      .getAssignedRolesFolder(this.reference.folder.parentId)
      .subscribe((res: any) => {


        let dialogRef2 = this.dialog.open(SecurityComponent, {
          width: "70vw",
          data: {
            unAssigendRole: res.unassingedRoles,
            assigendRoles: res.assingedRoles,
          },
        });
        dialogRef2.afterClosed().subscribe((result) => {
          if (result) {
            this.openRole = false;
            result.assigendRoles = result.assigendRoles.map((x) => x.id);
            let rolesAndAsigend: any = {
              folderIds: [this.reference.folder.parentId],
              roleIds: result.assigendRoles,
            };

            this.mdeiaService
              .updateAssignedRolesFolder(rolesAndAsigend)
              .subscribe((res) => {
                this.snotifyService.success("Roles updated successfully");
              });
          }else{
            this.openRole = false;
          }
        });
      });
  }


  close() {
    this.dialogRef.close();
  }

  submit() {
    if (this.openRole) {
      return;
    }


    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((feild) => {
        this.form.controls[feild].markAsTouched({ onlySelf: true });
      });



      return;
    }



    if (this._folderDetails.invalid) {
      Object.keys(this.form.controls).forEach((feild) => {
        this.form.controls[feild].markAsTouched({ onlySelf: true });
      });



      return;
    }

    this.mdeiaService.create(this.form.value).subscribe(

      (res: any) => {
        this.close();
        this.mdeiaService.getAllSideFolders();
        // this.mdeiaService.getFoldersFirstTime()
        this.mdeiaService
          .searchMediaAndFolders(res.currentFolderId)
          .subscribe((res: any) => {
          });

        this.mdeiaService.searchMediaAndFolders(res.currentFolderId);
        // this.mdeiaService.getFolders(this.reference.folder.parentId).subscribe();

    
        if (this.reference.method === "Edit"){
          this.openNotifySuccess("Added  Successfully");

        }else {

          this.openNotifySuccess("Edited  Successfully");

        }
      }
    ), err => {
     this.openNotifyError(err)
    }

  
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }


   openNotifyError(message: any) {
  this.snotifyService.error(message.error, "Something went wrong!!", {
            timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
          });
  }

  get _id() {
    return this.form.get("id");
  }
  get _parentId() {
    return this.form.get("parentId");
  }
  get _title() {
    return this.form.get("title");
  }
  get _description() {
    return this.form.get("description");
  }
  get _cultureId() {
    return this.form.get("cultureId");
  }
  get _order() {
    return this.form.get("order");
  }
  get _folderDetails() {
    return this.form.get("mediaFoldersDetails") as FormArray;
  }
}
